<template>
  <span>
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="options"
          icon
          class="ml-auto"
          v-bind="attrs"
          v-on="on"
          :disabled="loading || !userOptions.length"
        >
          <v-icon v-text="'ph-fill ph-dots-three-outline-vertical'" />
        </v-btn>
      </template>
      <v-list style="width: 350px" dense class="py-0">
        <v-list-item
          v-for="(option, i) in userOptions"
          :key="i"
          v-show="option.show"
          @click="() => option.execute()"
          :disabled="option.disabled || loading"
          class="text-body-2 font-weight-medium"
          :data-testid="`migration-option-${i}`"
        >
          <v-list-item-icon class="mr-2">
            <v-icon v-text="option.icon" :color="option.iconColor" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ option.text }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <SimpleDialog
      :show="showCancelDialog"
      :title="
        isInProgress
          ? $t('cancelMigrationDialog.titleInterrupt')
          : $t('cancelMigrationDialog.titleCancel')
      "
      :customButtom="true"
      outlined
      dense
      showCancel
      :actionText="$t('cancelMigrationDialog.confirm')"
      :showLoading="loading"
      :disabledAction="loading"
      :closeText="$t('cancelMigrationDialog.cancel')"
      @action="runCancelMigration"
      @close="closeCancelDialog"
      width="700"
    >
      <template v-slot:body>
        <p v-if="isInProgress" class="mt-2 text-title-1">
          {{ $t("cancelMigrationDialog.infoInterrupt") }}
        </p>
        <p v-else class="mt-2 text-title-1">
          {{ $t("cancelMigrationDialog.infoCancel") }}
        </p>

        <Alert :prominent="false" color="warning">
          {{ $t("cancelMigrationDialog.warning") }}
        </Alert>
      </template>
    </SimpleDialog>
  </span>
</template>

<script>
import { getMigrationStatusCode } from "@/helpers/variables/migrations";
import { mapActions } from "vuex";

const migrationStatusCode = getMigrationStatusCode();

export default {
  name: "Actions",

  props: {
    history: { type: Object, required: true },
  },

  data: () => ({
    loading: false,
    showCancelDialog: false,
  }),

  computed: {
    isInProgress() {
      return this.history.status === "IN_PROGRESS";
    },

    userOptions() {
      const inQueueOrProgress = [
        "IN_QUEUE",
        // "IN_PROGRESS"
      ].includes(this.history.status);

      const text = this.isInProgress
        ? this.$t("migrationHistory.optionInterrupt")
        : this.$t("migrationHistory.optionCancel");

      const nextStatus = this.isInProgress ? "INTERRUPTED" : "CANCELED";

      const { icon, colorIcon } = migrationStatusCode[nextStatus];

      return [
        {
          text,
          icon,
          iconColor: colorIcon,
          execute: this.openCancelDialog, // to runCancelMigration
          show: inQueueOrProgress,
          disabled: !inQueueOrProgress,
        },
      ].filter((item) => item.show);
    },
  },

  methods: {
    ...mapActions(["cancelMigration"]),

    runCancelMigration() {
      this.loading = true;
      this.cancelMigration(this.history.migration_key).finally(() => {
        this.loading = false;
        this.closeCancelDialog();
      });
    },

    openCancelDialog() {
      this.showCancelDialog = true;
    },

    closeCancelDialog() {
      this.showCancelDialog = false;
    },
  },
};
</script>
